// ============================================================
// taskDue.ts — the task form's due date + time → the dueDate the backend
// stores (pure; taskDue.test.ts). Moved out of TasksView so the autosave
// path is tested.
//   - no date       → null (no due date — ONLY on a deliberate clear: the
//                     DateInput never reports a half-typed date, so a
//                     half-typed edit can't reach here as null)
//   - date, no time → the date string (all-day)
//   - date + time   → a full ISO instant from LOCAL parts (the user's 14:00
//                     is 14:00 in their timezone)
// ============================================================
export const combineDue = (date: string | null, time: string | null): string | null => {
  if (!date) return null
  if (!time) return date
  const [y, mo, d] = date.split('-').map(Number)
  const [hh, mm] = time.split(':').map(Number)
  if ([y, mo, d, hh, mm].some((n) => Number.isNaN(n))) return date
  return new Date(y, mo - 1, d, hh, mm).toISOString()
}
